const a=a=>a.reduce(((a,t)=>(t?.slugPath&&(a[t.slugPath]={id:t.id,name:t.name??"",path:t.path??"",slugPath:t.slugPath}),a)),{});export{a as transformCfhsMetadataToSlugPathMap};
